module.exports = __webpack_public_path__ + "img/DumpTruck.b87af26f.png";